/**
 * Created by lihanying on 2017/7/6.
 */

export const GETWORKERLIST = 'GETWORKERLIST'


// WEBPACK FOOTER //
// ./src/containers/ClubEmployee/constants.js